const apiDomain = 'tjennake.com'
const cdnDomain = 'tjennake.com'

export default {
  //systemName: '莫小红微店',
	systemName: '满爸小儿健康微店',
  tokenName: 'TOKEN',
	indexURL: '/',
  homeURL: '/home',
	upload: {
		useCdnDomain: true,
		region: 'z1'
	},
	download: {
		image: `http://image.${cdnDomain}`
	},
  request: {
    production: `https://shop-api.${apiDomain}`,
		development: `http://shopapi-dev.${apiDomain}`
  },
  version: 'V1.0.0'
}